/** Where a signed-in person lands: the workers directory. `/` is the public
 * landing page, so nothing inside the app may link or redirect there. */
export const APP_HOME = "/workers";
